﻿import InputBase from '@mui/material/InputBase';
import { styled } from '@mui/material/styles';

let TextField = styled(InputBase)(({ theme }) => ({
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '4px',
    '& .MuiInputBase-input': {
        height: '20px',
        padding: '12px 16px',
        fontSize: '14px'
    }
}));

export default TextField;
